import React from 'react';
import { History, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export function AdminActivityLogSection({ 
    activityLog, 
    onClearLog 
}) {
    const formatTimestamp = (timestamp) => {
        if (!timestamp) return 'N/A';
        const date = new Date(timestamp);
        return date.toLocaleString('en-GB', {
            day: 'numeric',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getActionColor = (action) => {
        if (action === 'created') return 'bg-green-100 text-green-700';
        if (action === 'updated') return 'bg-blue-100 text-blue-700';
        if (action === 'deleted') return 'bg-red-100 text-red-700';
        return 'bg-gray-100 text-gray-600';
    };

    return (
        <div className="space-y-6" data-testid="admin-activity-log">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">Manager Activity Log</h2>
                {activityLog.length > 0 && (
                    <Button 
                        variant="outline" 
                        size="sm"
                        onClick={onClearLog}
                        data-testid="clear-activity-log"
                    >
                        <Trash2 className="w-4 h-4 mr-2" />
                        Clear Log
                    </Button>
                )}
            </div>

            <p className="text-sm text-muted-foreground">
                Track all content changes made by managers for admin oversight.
            </p>
            
            <div className="space-y-2">
                {activityLog.map((log, idx) => (
                    <div key={log.id || idx} className="card-base py-3" data-testid={`activity-log-${idx}`}>
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
                            <div className="flex items-center gap-3">
                                <span className={`text-xs font-bold px-2 py-1 rounded-full ${getActionColor(log.action)}`}>
                                    {log.action}
                                </span>
                                <div>
                                    <span className="font-medium">{log.manager_name || log.manager_email}</span>
                                    <span className="text-muted-foreground mx-2">{log.action}</span>
                                    <span className="text-primary">{log.content_type}</span>
                                    {log.content_title && (
                                        <span className="text-muted-foreground">: "{log.content_title}"</span>
                                    )}
                                </div>
                            </div>
                            <span className="text-xs text-muted-foreground">
                                {formatTimestamp(log.timestamp)}
                            </span>
                        </div>
                        {log.details && (
                            <p className="text-sm text-muted-foreground mt-2 pl-20">
                                {log.details}
                            </p>
                        )}
                    </div>
                ))}
                
                {activityLog.length === 0 && (
                    <div className="card-base text-center py-12">
                        <History className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                        <p className="text-muted-foreground">No manager activity recorded yet</p>
                    </div>
                )}
            </div>
        </div>
    );
}
